import React from 'react';
import TransactionHistoryFunctional from './components/transaction-history-functional';
import './transaction-history.scss';

const TransactionHistory = () => {
	return <TransactionHistoryFunctional />;
};

export default TransactionHistory;
